module.exports = __webpack_public_path__ + "static/media/LMU-Logo.1244b4e4.png";